const fn = {
  init: () => {
    const el = document.querySelector('.element-benefits')

    el.style.setProperty('--image-max-height', `${el.offsetHeight}px`)
  },
}

export default {
  can: () => document.querySelectorAll('.element-benefits').length,
  run: fn.init,
}
